export default __webpack_public_path__ + "static/media/02AW2JAN66.629f0d09.jpg";